import React, { Component } from 'react';

import CartPanel from '../CartPanel/CartPanel';
import Products from '../Products/Products';

class Wrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cart: [],
      totalPrice: 0,
      totalQuantity: 0,
    };
    this.currencyOptions = {
      style: 'currency',
      currency: 'PLN',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };
    this.updateCart = this.updateCart.bind(this);
  }

  updateCart = (name, quantity = 0, itemprice = 0, action = 'add') => {
    // check action type (either add or delete)
    const request = action;

    const getTotalPrice = () => {
      this.setState((prevState) => {
        const prevCart = prevState.cart;
        const totalPrice = prevCart.reduce(
          (total, item) => total + item.itemprice * item.quantity,
          0
        );
        return {
          totalPrice,
        };
      });
    };

    const getTotalQuantity = () => {
      this.setState((prevState) => {
        const prevCart = prevState.cart;
        const totalQuantity = prevCart.reduce(
          (total, item) => total + item.quantity,
          0
        );
        return {
          totalQuantity,
        };
      });
    };

    this.setState(
      (prevState) => {
        if (request === 'remove') {
          console.log('were removing!');
          const prevCart = prevState.cart;
          const elToDelete = prevCart.find((item) => item.name === name);
          const newCart = prevCart.filter((item) => item !== elToDelete);
          console.log(newCart);
          return {
            cart: newCart,
          };
          // eslint-disable-next-line no-else-return
        } else {
          console.log('were adding?');
          // update quantity if already exists or add new
          const prevCart = prevState.cart;

          const alreadyExists = prevCart.some((item) => item.name === name);
          if (alreadyExists) {
            const elToDelete = prevCart.find((item) => item.name === name);
            const oldQuantity = elToDelete.quantity;
            console.log(oldQuantity);
            const newCart = [
              ...prevCart.filter((item) => item !== elToDelete),
              {
                name,
                quantity: oldQuantity + 1,
                itemprice,
              },
            ];
            return {
              cart: newCart,
            };
            // eslint-disable-next-line prettier/prettier
          }
          // eslint-disable-next-line no-else-return
          else {
            // just add new item if same name doesn't exist
            const newCart = [
              ...prevCart,
              {
                name,
                quantity: 1,
                itemprice,
              },
            ];
            return {
              cart: newCart,
            };
          }
        }
      },
      () => {
        getTotalPrice();
        getTotalQuantity();
      }
    );
  };

  render() {
    const { totalPrice, totalQuantity } = this.state;
    return (
      <div className="wrapper">
        <CartPanel
          currencyOptions={this.currencyOptions}
          totalPrice={totalPrice}
          totalQuantity={totalQuantity}
        />
        <Products updateCart={this.updateCart} />
      </div>
    );
  }
}

export default Wrapper;
